<template>
  <div :class="modalMode ? 'pt-6' : null">
    <cheque-tabs v-if="!modalMode" :type="isPaid"></cheque-tabs>
    <m-form
      :title="title"
      :showListBtn="false"
      :showList="false"
      :listRoute="{ name: 'ChequesList', params: { type, isPaid } }"
      :showNavigationButtons="!modalMode"
      :showSubmitAndClearForm="!modalMode"
      :canDelete="canDelete"
      :show-submit-and-clear-btn="!modalMode"
      :canSubmit="canSubmit"
      :canEdit="canEdit"
      :isEditing.sync="isEditing"
      @clearForm="clearForm"
      @goToForm="getItemByPosition"
      @submit="validate"
      @delete="deleteItem"
    >
      <template #header-btns>
        <v-btn
          v-if="item.id"
          depressed
          class="secondary white--text mr-2 ml-2 mt-1 rounded-lg"
          :to="{ name: 'ChequeDetail', id: id }"
          >مشاهده جزئیات {{ typeName }}
        </v-btn>
      </template>

      <template>
        <v-row>
          <v-col cols="12" md="2">
            <div id="cheque-form-account">
              <account-select
                :label="isPaid ? 'پرداخت به' : ' دریافت از'"
                items-type="level3"
                v-model="itemAccount"
                :disabled="modalMode || !isEditing"
                :floatAccount1.sync="itemFloatAccount1"
                :floatAccount2.sync="itemFloatAccount2"
                :floatAccount3.sync="itemFloatAccount3"
                :floatAccount4.sync="itemFloatAccount4"
              />
            </div>
          </v-col>

          <template v-if="isPaid">
            <v-col cols="12" md="2">
              <div id="cheque-form-bank">
                <account-select
                  :itemsType="accountUsage.BANK"
                  label="* بانک"
                  v-model="cheque.bank"
                  :disabled="!isEditing || id != null"
                  :deepSelect="false"
                  clearable
                  @change="getBankChequebooks(cheque.bank)"
                />
              </div>
            </v-col>
            <v-col cols="12" md="2" v-if="isPaid">
              <div id="cheque-form-cheque-book">
                <v-autocomplete
                  class="rounded-lg"
                  :return-object="true"
                  required
                  label="سری دسته چک"
                  :items="bankChequebookItems"
                  item-text="serial"
                  item-value="id"
                  v-model="cheque.chequebook"
                  :disabled="!isEditing || id != null"
                  @change="d.getChequebookCheques"
                  clearable
                />
              </div>
            </v-col>
          </template>
          <v-col cols="12" md="2" v-if="isPaid">
            <div id="cheque-form-serial">
              <v-autocomplete
                :loading="loading.getChequebookCheques"
                class="rounded-lg"
                required
                label="* سریال"
                v-model="cheque.serial"
                :items="blankCheques"
                item-text="serial"
                item-value="serial"
                :disabled="!isEditing || id != null"
              />
            </div>
          </v-col>
          <v-col cols="12" md="1" v-if="!isPaid">
            <div id="cheque-form-serial">
              <v-text-field
                class="rounded-lg"
                required
                label=" * شماره چک"
                v-model="cheque.serial"
                :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" :md="isPaid ? 3 : 2">
            <div id="cheque-form-iban">
              <v-text-field
                class="rounded-lg"
                required
                label="شماره صیادی"
                v-model="item.iban"
                :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" md="1">
            <div id="cheque-form-value">
              <money label=" * مبلغ" v-model="item.value" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" :md="isPaid ? 2 : 1" v-if="canSetSanadCode">
            <div id="cheque-form-sanad-code">
              <v-text-field
                  class="rounded-lg"
                  label="شماره سند"
                  v-model="item.sanad_code"
                  :disabled="!isEditing || modalMode"
              />
            </div>
          </v-col>
          <v-col cols="12" md="1">
            <div id="cheque-is-long-term">
              <v-autocomplete
                class="rounded-lg"
                label=" مدت"
                :items="TERM_CHOICES"
                v-model="item.is_long_term"
                item-text="title"
                item-value="value"
                :disabled="!isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" md="2" v-if="type == 'bg'">
            <div id="cheque-form-account-number">
              <v-text-field label="شماره سپام" v-model="item.accountNumber" :disabled="!isEditing" class="rounded-lg" />
            </div>
          </v-col>
          <v-col cols="12" md="2" v-if="type == 'bg'">
            <div id="cheque-form-due">
              <date label="تاریخ اعتبار" v-model="item.due" :default="false" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="2" v-else>
            <div id="cheque-form-due">
              <date label="* تاریخ سررسید" v-model="item.due" :default="false" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div id="cheque-form-date">
              <date label="* تاریخ ثبت" v-model="item.date" :default="true" :disabled="!isEditing" />
            </div>
          </v-col>
          <v-col cols="12" md="2" v-if="type == 'c' && !isPaid">
            <div id="cheque-form-owner-type">
              <v-select
                class="rounded-lg"
                label="نوع چک"
                :items="chequeOwnerTypes"
                :return-object="false"
                v-model="item.owner_type"
                :disabled="!isEditing"
              ></v-select>
            </div>
          </v-col>
          <v-col cols="12" md="2" v-show="!isPaid">
            <div id="cheque-form-bank-name">
              <v-autocomplete
                class="rounded-lg"
                label=" نام بانک"
                :items="BANK_NAMES"
                v-model="item.bankName"
                item-text="name"
                item-value="name"
                :disabled="isPaid || !isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" md="2" v-show="!isPaid">
            <div id="cheque-form-branch-name">
              <v-text-field
                class="rounded-lg"
                v-if="type != 'pn'"
                label="نام شعبه"
                v-model="item.branchName"
                :disabled="isPaid || !isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" md="2" v-show="!isPaid">
            <div id="cheque-form-account-number">
              <v-text-field
                class="rounded-lg"
                v-if="type == 'c'"
                label="شماره حساب"
                v-model="item.accountNumber"
                :disabled="isPaid || !isEditing"
              />
            </div>
          </v-col>
          <v-col cols="12" :md="isPaid ? 5 : 4">
            <div id="cheque-form-explanation">
              <v-textarea class="rounded-lg" label="شرح " v-model="item.explanation" :disabled="!isEditing" />
            </div>
          </v-col>
        </v-row>
      </template>
    </m-form>
    <cheques-list v-if="!modalMode" class="mt-3" form="cheque" :type="type" :isPaid="isPaid" ref="formList" />
  </div>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import ChequeMixin from "./mixin.js";
import ChequesList from "@/views/panel/lists/ChequesList";
import formsMixin from "@/mixin/forms";
import GetChequebooksApi from "@/views/panel/chequebook/getChequebooksApi";
import { MFormMixin } from "@/components/m-form";
import ChequeTabs from "@/views/panel/cheque/ChequeTabs";

export default {
  name: "ChequeForm",
  props: {
    isPaid: {
      requried: true,
    },
    type: {
      requried: true,
    },
    modalMode: {
      default: false,
    },
    selectedAccount: {
      default: null,
    },
    chequeData: {
      default: null,
    },
  },
  components: { ChequeTabs, money, date, ChequesList },
  mixins: [ChequeMixin, accountApiMixin, formsMixin, GetChequebooksApi, MFormMixin],
  data() {
    return {
      bankChequebookItems: [],
      baseUrl: "cheques/cheques",
      hasList: false,
      hasIdProp: true,
      d: {},
      loading: {},

      itemAccount: null,
      itemFloatAccount1: null,
      itemFloatAccount2: null,
      itemFloatAccount3: null,
      itemFloatAccount4: null,

      cheque: {
        bank: null,
        chequebook: null,
        serial: null,
      },

      chequebookCheques: [],
    };
  },
  computed: {
    blankCheques() {
      if (this.id) return this.chequebookCheques;
      return this.chequebookCheques.filter((o) => o.status == "blank");
    },
    createUrl() {
      return "cheques/cheques/submit/";
    },
    permissionBasename() {
      if (this.isPaid) {
        return "paidCheque";
      } else {
        return "receivedCheque";
      }
    },
    canSubmit() {
      return this.hasPerm("submit", this.permissionBasename, this.item);
    },
    canEdit() {
      if (this.item.id && this.item.financial_year != this.financialYear.id) return false;
      return this.item.status != "revoked";
    },
    typeName() {
      return this.getTypeName(this.type);
    },
    title() {
      let title = this.typeName;
      if (this.isPaid) title += " پرداختنی";
      else title += " دریافتنی";
      return this.setDocumentTitle(title);
    },
    canSetSanadCode() {
      let statusChange = this.item.statusChanges;
      if (statusChange) {
        return statusChange.length == 0;
      } else {
        return true;
      }
    },

    canDelete() {
      if (this.isPaid) return false;
      if (this.item.id) {
        let statusChangesLength = this.item.statusChanges.length;
        if (this.isPaid) {
          if (statusChangesLength == 0) return true;
        } else {
          if (statusChangesLength == 1) return true;
        }
        return false;
      }
      return false;
    },
  },
  created() {
    this.d.getChequebookCheques = _.debounce(this.getChequebookCheques, 500);

    this.getAccounts();
    if (this.id) {
      this.getCheque(this.id);
    }

    if (this.isPaid) {
      this.getChequebooks();
    }
  },
  mounted() {
    this.checkSelectedAccount();
    this.checkChequeData();
    this.getChequebooks()
  },
  watch: {
    selectedAccount: {
      handler() {
        this.checkSelectedAccount();
      },
      deep: true,
    },
    chequeData: {
      handler() {
        this.checkChequeData();
      },
      deep: true,
    },
    "cheque.bank"() {
      this.d.getChequebookCheques();
    },
  },
  methods: {
    checkSelectedAccount() {
      if (this.selectedAccount) {
        this.itemAccount = this.selectedAccount.account;
        this.itemFloatAccount1 = this.selectedAccount.floatAccount1;
        this.itemFloatAccount2 = this.selectedAccount.floatAccount2;
        this.itemFloatAccount3 = this.selectedAccount.floatAccount3;
        this.itemFloatAccount4 = this.selectedAccount.floatAccount4;
      }
    },
    checkChequeData() {
      if (this.chequeData) {
        if (this.chequeData.item) {
          Object.keys(this.chequeData.item).forEach((key) => {
            this.item[key] = this.chequeData.item[key];
          });
        }
        if (this.chequeData.cheque) {
          Object.keys(this.chequeData.cheque).forEach((key) => {
            this.cheque[key] = this.chequeData.cheque[key];
          });
        }
      }
    },
    submit(clearForm = true) {
      if (this.hasConfirmation) {
        if (!confirm("از انجام این عملیات اطمینان دارید؟")) return;
      }
      if (this.isPaid || this.id) {
        this.updateItem(clearForm);
      } else {
        this.storeItem(clearForm);
      }
    },
    getBankChequebooks(bank) {
      if (bank && this.isPaid) {
        this.bankChequebookItems = this.chequebooks.filter((o) => o.account.id == bank.id);
      } else {
        this.bankChequebookItems = [];
      }
    },
    clearForm() {
      this.isEditing = true;
      this.item = this.getItemTemplate();

      if (!this.modalMode) {
        this.changeRouteTo(null);
      }

      this.cheque.bank = null;
      this.cheque.chequebook = null;
      this.cheque.serial = null;
      this.itemAccount = null;
      this.itemFloatAccount1 = null;
      this.itemFloatAccount2 = null;
      this.itemFloatAccount3 = null;
      this.itemFloatAccount4 = null;

      this.checkSelectedAccount();
      this.checkChequeData();
    },
    getData() {
      if (this.$refs.formList) {
        this.$refs.formList.$refs.datatable.getData();
      }
    },
    validate(clearForm) {
      if (this.modalMode) {
        this.$emit("submit", {
          item: this.getSerialized(),
          cheque: this.cheque,
        });
      } else {
        this.submit(clearForm);
      }
    },
    getItemTemplate() {
      let template = {
        type: this.type,
        account: null,
        is_paid: this.isPaid,
        due: null,
        date: null,
      };

      return template;
    },
    getSerialized() {
      this.item.account = this.itemAccount;
      this.item.floatAccount1 = this.itemFloatAccount1;
      this.item.floatAccount2 = this.itemFloatAccount2;
      this.item.floatAccount3 = this.itemFloatAccount3;
      this.item.floatAccount4 = this.itemFloatAccount4;
      this.item.serial = this.cheque.serial;

      if (this.isPaid && !this.id) {
        this.item.id = this.blankCheques.find((o) => o.serial == this.cheque.serial).id;
      }

      let data = this.extractIds(this.item);

      this.removeAttachmentUrls(data);
      if (this.formData) {
        data = this.jsonToFormData(data);
      }
      return data;
    },
    getItemByPosition(pos) {
      return this.request({
        url: this.endpoint("cheques/getChequeByPosition"),
        method: "get",
        params: {
          is_paid: this.isPaid,
          type: this.type,
          id: this.id,
          position: pos,
        },
        success: (data) => {
          this.setItem(data);
        },
        error: (error) => {
          if (error.response.status == 404) {
            this.notify("مورد وجود ندارد", "warning");
          }
        },
      });
    },
    setItem(item) {
      this.item = item;
      if (this.id != item.id) {
        this.changeRouteTo(item.id);
      }

      if (this.isPaid) {
        this.cheque.bank = item.chequebook.account;
        this.cheque.chequebook = item.chequebook;
        this.getChequebookCheques();
      }
      this.cheque.serial = item.serial;
      this.isEditing = false;

      if (this.$refs.formList) {
        this.$refs.formList.$refs.datatable.getDataFromApi();
      }

      this.itemAccount = this.item.account;
      this.itemFloatAccount1 = this.item.floatAccount1;
      this.itemFloatAccount2 = this.item.floatAccount2;
      this.itemFloatAccount3 = this.item.floatAccount3;
      this.itemFloatAccount4 = this.item.floatAccount4;
    },
    getChequebookCheques() {
      this.chequebookCheques = [];

      if (!this.cheque.chequebook) return;

      this.loading.getChequebookCheques = true;

      this.request({
        url: this.endpoint("reports/lists/chequebookCheques"),
        method: "get",
        loading: false,
        params: {
          chequebook__id: this.cheque.chequebook.id,
        },
        success: (data) => {
          this.chequebookCheques = data;
          this.loading.getChequebookCheques = false;
        },
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
